import axios from "axios";
import { getToken, removeToken } from "./auth";
import { Message } from "element-ui";
import router from "@/router/premission.js";
import { GetRequest } from "@/utils/auth.js";
import qs from "qs";
const instance = axios.create();
instance.defaults.timeout = 15000;
instance.defaults.baseURL = process.env.DEV_API; // 填写域名
let pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const CancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + "&" + config.method) {
      // 当当前请求在数组中存在时执行函数体
      pending[p].f(); // 执行取消操作
      pending.splice(p, 1); // 把这条记录从数组中移除
    }
  }
};

let cutReq = (config) => {
  let flag = false;
  for (let p in pending) {
    if (pending[p].u === config.baseURL + config.url + "&" + config.method) {
      // 当当前请求在数组中存在时执行函数体
      flag = true;
    }
  }
  return flag;
};
// http request 拦截器
instance.interceptors.request.use(
  (config) => {
    let flag = cutReq(config);
    // if (flag === true) return null // 当上一次相同请求未完成时，无法进行第二次相同请求
    config.cancelToken = new CancelToken(
      (c) => {
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        let first = config.url[0];
        let pushurl = "";
        if (first === "/") {
          pushurl = config.baseURL + config.url + "&" + config.method;
        } else {
          pushurl = config.baseURL + "/" + config.url + "&" + config.method;
        }
        pending.push({ u: pushurl, f: c });
      },
      (err) => {
        console.log(err);
      }
    );
    config.headers["token"] = getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器即异常处理
instance.interceptors.response.use(
  (res) => {
    removePending(res.config); // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    if (typeof res.data === "string") {
      res.data = JSON.parse(res.data);
    }
    let code = Object.is(res.data.errcode, undefined)
      ? res.data.code
      : res.data.errcode;
    let code1 = res.data.code;
    if (code !== 0) {
      console.log("code", code);
      // token无效 跳转到登陆 或者为单点登录时 异常就跳转到登陆
      if (code === 4012 || GetRequest("token") || code1 === 4012) {
        Message({
          message: "用户已信息失效,请重新登陆",
          type: "error",
          duration: 3 * 1000,
        });
        //清除
        removeToken();
        setTimeout(() => {
          router.push({ name: "login" });
          window.location.reload();
        }, 1000);
      } else {
        Message({
          message: res.data.message,
          type: "error",
          duration: 3 * 1000,
        });
      }

      throw new Error(res.data.message);
    }
    // console.log(pending)
    return res.data;
  },
  (err) => {
    if (err.config) removePending(err.config); // 即使失败 也要把已经完成的请求从pending中移除
    let errmsg = "";
    if (err.message.includes("cancelToken")) {
      // if (Object.is(err.message, undefined)) {
      errmsg = "请不要重复操作";
    } else {
      try {
        errmsg = err.response.data.message;
      } catch (error) {
        errmsg = "网络错误，服务器无响应或超时，请尝试重新刷新页面！";
      }
    }
    Message({
      message: errmsg,
      type: "error",
      duration: 3 * 1000,
    });
    if (err.response && err.response.data.errcode === 401)
      router.push({ name: "login" });
    return Promise.reject(err);
  }
);

function fetch(url, params, method = "post", isformdata = false, config = {}) {
  // let postdata = {
  //   data: params
  // }
  // if (method === 'get') {
  //   postdata = {
  //     params: params
  //   }
  // }
  if (method === "post" && isformdata) {
    config.data = qs.stringify(params);
  }
  return new Promise((resolve, reject) => {
    instance({
      url,
      method,
      data: method === "post" ? params : {},
      params: method === "get" ? params : {},
      ...config,
    })
      .then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
export default fetch;



// WEBPACK FOOTER //
// ./src/utils/http-service.js